import { CheckCircle2, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CaseLeftNav({ caseData, stage, stagesDone, onStageChange, variant = "desktop" }) {
  const nav = useNavigate();
  const isSheet = variant === "sheet";
  return (
    <aside
      className={isSheet ? "flex flex-col w-full" : "w-72 border-r flex flex-col shrink-0"}
      style={{
        borderColor: "var(--border-stone)",
        background: isSheet ? "transparent" : "var(--bg-app)",
      }}
    >
      <div className={`${isSheet ? "px-3 pb-4 mb-3" : "p-5"} border-b`} style={{ borderColor: "var(--border-stone)" }}>
        {!isSheet && (
          <button
            data-testid="back-to-dashboard-btn"
            onClick={() => nav("/")}
            className="flex items-center gap-1.5 text-xs mb-3 hover:underline"
            style={{ color: "var(--text-secondary)" }}
          >
            <ArrowLeft className="w-3 h-3" /> All cases
          </button>
        )}
        <div className="pill pill-ai capitalize mb-2">{caseData.relationship} · DS-260</div>
        <div className="font-display font-bold leading-tight" style={{ color: "var(--text-primary)" }}>
          {caseData.data?.beneficiary_first_name || "New beneficiary"}{" "}
          {caseData.data?.beneficiary_last_name || ""}
        </div>
        <div className="mt-3 h-1.5 rounded-full overflow-hidden" style={{ background: "var(--border-stone)" }}>
          <div
            className="h-full transition-all"
            style={{ width: `${caseData.completion_percent}%`, background: "var(--action)" }}
          />
        </div>
        <div className="mt-1.5 text-[11px]" style={{ color: "var(--text-secondary)" }}>
          {caseData.completion_percent}% complete
        </div>
      </div>

      <nav className={isSheet ? "px-2 pb-4 space-y-1" : "p-3 flex-1 overflow-y-auto"}>
        {caseData.stages.map((s) => (
          <div
            key={s.id}
            data-testid={`stage-nav-${s.id}`}
            onClick={() => onStageChange(s.id)}
            className={`stage-item ${stage === s.id ? "active" : ""} ${stagesDone.has(s.id) ? "done" : ""}`}
          >
            <div className="dot" />
            <div className="flex-1">{s.label}</div>
            {stagesDone.has(s.id) && <CheckCircle2 className="w-4 h-4" style={{ color: "#065F46" }} />}
          </div>
        ))}
      </nav>
    </aside>
  );
}
